import baseApi from '@/store/api/baseApi';

export const supplierOnboardingCostingApiSlice = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getSupplierOnboardingCosting: builder.query({
			query: (supplierId) => ({
				url: `supplier/onboarding-costing/${supplierId}`,
				method: 'GET'
			})
		}),
		addSupplierOnboardingCosting: builder.mutation({
			query: ({ supplierId, body }) => ({
				url: `supplier/onboarding-costing/add/${supplierId}`,
				method: 'POST',
				body
			})
		}),
		updateSupplierOnboardingCosting: builder.mutation({
			query: ({ id, body }) => ({
				url: `supplier/onboarding-costing/${id}`,
				method: 'PUT',
				body
			})
		}),
		deleteSupplierOnboardingCosting: builder.mutation({
			query: (id) => ({
				url: `supplier/onboarding-costing/${id}`,
				method: 'DELETE'
			})
		}),
		deleteSupplierOnboardingCostingDocument: builder.mutation({
			query: (id) => ({
				url: `supplier/onboarding-costing/${id}/document`,
				method: 'DELETE'
			})
		})
	})
});

export const {
	useGetSupplierOnboardingCostingQuery,
	useAddSupplierOnboardingCostingMutation,
	useUpdateSupplierOnboardingCostingMutation,
	useDeleteSupplierOnboardingCostingMutation,
	useDeleteSupplierOnboardingCostingDocumentMutation
} = supplierOnboardingCostingApiSlice;
